<template>
  <div>
    <van-nav-bar
        style="background: #ffffff;color:#323233;font-weight: bold"
        fixed
        title="采购入库"
        left-arrow
        @click-left="onClickLeft"
    />
    <div id="aaa"></div>

    <van-cell-group title="影像中心" :border="false" style="margin-left: 10px;">
      <van-cell
          icon="location-o"
          :title="currentAgent.name"
          is-link
          @click="toPwalist"
          style="border-bottom:0.1px solid 	#F5F5F5"
      />
    </van-cell-group>
    <van-cell-group title="采购订单" :border="false" style="margin-left: 10px;">
      <van-cell
          icon="orders-o"
          :title="purchaseOrderNum"
          is-link
          @click="toOrderList"
          style="border-bottom:0.1px solid 	#F5F5F5"
      />
    </van-cell-group>

    <van-cell-group title="备注" :border="false" style="margin-left: 10px;">
      <van-cell icon="edit" style="border-bottom:0.1px solid 	#F5F5F5">
        <van-field
            v-model="message"
            rows="2"
            autosize
            type="textarea"
            maxlength="50"
            placeholder="请输入备注信息"
            show-word-limit
        />
      </van-cell>
    </van-cell-group>

    <van-cell-group title="入库仓库" :border="false" style="margin-left: 10px;">
      <van-cell class="choiceWarhouse" style="border-bottom:0.1px solid 	#F5F5F5">
        <van-row type="flex">
          <van-col span="24">
            <van-tag
                v-for="(warehousename,warehouseindex) in currentAgent.warehouse"
                :key="warehouseindex"
                round
                :class="{selected:warehousename.id==warehouseMainDefaultSel}"
                @click="mainSelect(warehousename.id)"
            >{{warehousename.warehouse_name}}</van-tag>
          </van-col>
        </van-row>
      </van-cell>
    </van-cell-group>
    <van-cell-group title="入库明细" :border="false">
      <van-cell class="haha">
        <van-cell
            v-for="(item,index) in orderDetail"
            :key="index"
            :class="{selecteddetail:defaultDetail==index}"
            @click="toggleDetail(index)"
        >
          <van-row class="ha" type="flex">
            <van-col span="24">{{item.modelname}}</van-col>
          </van-row>
          <van-row type="flex" justify="space-between">
            <van-col span="8">
              <span style="color:#969799">采购数量:</span>
              <span style="color:#323233;font-weight:bold">{{item.apply_num}}</span>
            </van-col>
            <van-col span="8">
              <span style="color:#969799">已入数量:</span>
              <span style="color:#323233;font-weight:bold">{{item.apply_num - item.remain_sign_num}}</span>
            </van-col>
          </van-row>
          <van-row type="flex" justify="space-between"  style="margin-bottom: 5px;margin-right: 15px;" >
            <van-col span="5">
              <span style="color:#969799">有效范围:</span>
            </van-col>
            <!-- 生产日期 -->
            <van-col span="9">
              <!-- 生产日期部分 -->
              <van-dropdown-menu>
                <van-dropdown-item :title="item.pdDateStr || '生产日期'" ref="showpd">
                  <van-datetime-picker
                      v-model="item.pdDateRaw"
                      type="date"
                      title="生产日期"
                      @confirm="(val) => confirmPD(val, index)"
                      @cancel="cancelPD(index)"
                  />
                </van-dropdown-item>
              </van-dropdown-menu>
            </van-col>
            <van-col span="1">
              <span style="color:#969799">至</span>
            </van-col>
            <!-- 失效日期 -->
            <van-col span="9">
              <van-dropdown-menu>
                <van-dropdown-item :title="item.expDateStr || '失效日期'" ref="showexp">
                  <van-datetime-picker
                      v-model="item.expDateRaw"
                      type="date"
                      title="失效日期"
                      @confirm="(val) => confirmEXP(val, index)"
                      @cancel="cancelEXP(index)"
                  />
                </van-dropdown-item>
              </van-dropdown-menu>
            </van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="24">
              <span style="color:#969799">入库数量:</span>
              <input
                  type="text"
                  v-model="item.rknum"
                  @input="toastMes(index)"
                  style="width:75%;border:none"
              />
            </van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">
              <span style="color:#969799">选择仓库:</span>
            </van-col>
            <van-col span="18">
              <van-tag
                  plain
                  type="danger"
                  size="large"
                  color="#838683"
                  text-color="#838683"
                  v-for="(warehousenam,warehouseind) in currentAgent.warehouse"
                  :key="warehouseind"
                  round
                  :class="{selected:warehousenam.id==item.warehouseselected}"
                  @click="toggleDetSel(warehousenam.id,index)"
              >{{warehousenam.warehouse_name}}</van-tag>
            </van-col>
          </van-row>
        </van-cell>
      </van-cell>
    </van-cell-group>

    <van-cell-group title="上传签收单" :border="false" style="margin-left: 10px;">
      <span style="margin-left: 10px; font-size:20px; color:#f37979">提示：务必上传供应商的 "随货同行单" ！</span>
      <van-cell style="padding-left:18px">
        <van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead" />
      </van-cell>
    </van-cell-group>

<!--   上线用友关闭-->
    </van-cell-group>
        <van-cell-group>
          <van-cell>
            <van-button
                type="info"
                style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold"

                v-bind:disabled="flag"
            >系统切换,不允许入库</van-button>
          </van-cell>
        </van-cell-group>
<!--    <van-cell-group>-->
<!--      <van-cell>-->
<!--        <van-button-->
<!--            type="info"-->
<!--            style="font-size: 0.47333rem;background: #30cca8;border-radius: 50px;border: 0.02667rem solid #30cca8;font-weight:bold"-->
<!--            @click="qr"-->
<!--            v-bind:disabled="flag"-->
<!--        >提交入库</van-button>-->
<!--      </van-cell>-->
<!--    </van-cell-group>-->
<!--   上线用友关闭-->


    <div
        v-show="bottom_tip"
        style="font-size:10px;text-align:center;padding:10px 10px"
    >©2020 一脉阳光集团信息中心
    </div>
    <van-dialog v-model="show" title="请仔细核查" show-cancel-button @confirm="qrtj">
      <van-cell-group title="影像中心" :border="false" >
        <van-cell :title="currentAgent.name"/>
      </van-cell-group>
      <van-cell-group title="入库审核员" :border="false" >
        <van-cell :title="checker"/>
      </van-cell-group>
      <van-cell-group title="入库明细" :border="false" >
        <div class="dialogDiv">
        <van-cell
            v-for="(item,index) in orderDetail"
            :key="index"
        >
          <van-row type="flex">
            <van-col span="6">耗材型号：</van-col>
            <van-col span="18">{{item.modelname}}</van-col>
          </van-row>
          <van-row type="flex">
            <van-col span="6">入库数量：</van-col>
            <van-col span="18">{{item.rknum}}</van-col>
          </van-row>
        </van-cell>
        </div>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<script>
import {
  NavBar,
  Tag,
  DropdownMenu,
  DropdownItem,
  Col,
  Row,
  Panel,
  Divider,
  Button,
  Dialog,
  Toast,
  Uploader,
  DatetimePicker
} from "vant";
import { mapState, mapMutations } from "vuex";
import axios from "axios";
import Vue from 'vue';
Vue.use(DatetimePicker);
export default {
  components: {
    [NavBar.name]: NavBar,
    [Tag.name]: Tag,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Col.name]: Col,
    [DatetimePicker.name]: DatetimePicker,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [Panel.name]: Panel,
    [Divider.name]: Divider,
    [Row.name]: Row,
    [Uploader.name]: Uploader,
  },
  data() {
    return {
      show: false,
      fileList: [],
      img_url: "",
      uploadImages: [],
      //备注信息
      message: "",
      bottom_tip: true,
      //obj 选中的影像中心的所有采购订单信息
      purchaseOrderInfo: "",
      //选中的订单的所有信息
      purchaseOrderDetailinfo: "",
      //选中的订单的明细
      orderDetail: [],
      //客户端默认选中的明细（点击变色）
      defaultDetail: 0,
      //默认选中的主选仓库
      warehouseMainDefaultSel: -1,
      //当前选中的订单
      purchaseOrderNum: "",
      //当前选中的影像中心
      currentAgent: "",
      checker:"",
      flag: false,      //提交入库不重复点击
    };
  },

  methods: {
    ...mapMutations(["changePermissionAgent", "changeDefaultAgentIndex"]),
    onClickLeft() {
      this.$router.push("index");
    },
    mainSelect(index) {
      this.warehouseMainDefaultSel = index;
      for (let i = 0; i < this.orderDetail.length; i++) {
        this.orderDetail[i].warehouseselected = index;
      }
    },
    toggleDetail(index) {
      this.defaultDetail = index;
    },
    toggleDetSel(index, ind) {
      this.warehouseMainDefaultSel = -1;
      this.orderDetail[ind].warehouseselected = index;
      this.$forceUpdate();
    },
    // 生产日期确认
    confirmPD(val, index) {
      const dateStr = this.formatDate(val) // 使用日期格式化函数
      this.$set(this.orderDetail[index], "pdDateStr", dateStr);
      this.$set(this.orderDetail[index], "pdDateRaw", val);
      this.$refs.showpd[index].toggle(); // 关闭下拉菜单
    },

    // 失效日期确认
    confirmEXP(val, index) {
      const dateStr = this.formatDate(val) // 使用相同的格式化函数
      this.$set(this.orderDetail[index], "expDateStr", dateStr);
      this.$set(this.orderDetail[index], "expDateRaw", val);
      this.$refs.showexp[index].toggle(); // 关闭下拉菜单
    },

    // 日期格式化函数（示例）
    formatDate(date) {
      const d = new Date(date)
      return `${d.getFullYear()}-${(d.getMonth()+1).toString().padStart(2,'0')}-${d.getDate().toString().padStart(2,'0')}`
    },

    // 取消选择生产日期
    cancelPD(index) {
      // 使用 $set 确保响应式更新
      this.$set(this.orderDetail[index], "pdDateStr", "");
      this.$set(this.orderDetail[index], "pdDateRaw", null);
      // 关闭下拉菜单
      this.$refs.showpd[index].toggle(); // 关闭下拉菜单
      // 强制更新视图（仅在必要时）
      this.$forceUpdate();
    },
    cancelEXP(index) {
      // 使用 $set 确保响应式更新
      this.$set(this.orderDetail[index], "expDateStr", "");
      this.$set(this.orderDetail[index], "expDateRaw", null);
      // 关闭下拉菜单
      this.$refs.showexp[index].toggle(); // 关闭下拉菜单
      // 强制更新视图（仅在必要时）
      this.$forceUpdate();
    },

    qr() {
      this.show = true;
      // let that = this;
      // Dialog.confirm({
      //   message: "确认提交入库",
      // })
      //   .then(() => {
      //     if (!this.orderDetail[0]) {
      //       Toast("明细不能为空");
      //       return;
      //     }
      //     if (!this.img_url) {
      //       Toast("签收单不能空");
      //       return;
      //     }
      //     let result = this.parseSubmitData(this.orderDetail);
      //     //window.console.log(result);

      //     if (result.message) {
      //       Toast(result.message);
      //       return;
      //     } else {
      //       if (result.data[0]) {
      //         let data = {
      //           remark: this.message?this.message:"采购入库",
      //           creater: localStorage.getItem("workcode"),
      //           projectErpCode: this.currentAgent.erp_code,
      //           img: this.img_url,
      //           detail: result.data,
      //         };
      //         //window.console.log(data);
      //         Toast.loading({
      //           message: "加载中...",
      //           forbidClick: true,
      //         });

      //         this.$http({
      //           method: "post",
      //           url: "/mobile/warehousing",
      //           data,
      //         }).then(function (response) {
      //           if (response.state == 200) {
      //             Toast.success("入库成功");
      //             window.console.log(response);
      //             that.$router.push("index");
      //           }
      //         });
      //       } else {
      //         Toast("入库数量不能全部为空");
      //         return;
      //       }
      //     }
      //   })
      //   .catch(() => {
      //     // on cancel
      //   });
    },
    qrtj() {
      let that = this;
      if (!this.orderDetail[0]) {
        Toast("明细不能为空");
        return;
      }
      if (!this.img_url) {
        Toast("签收单不能空");
        return;
      }
      let result = this.parseSubmitData(this.orderDetail);
      //window.console.log(result);

      if (result.message) {
        Toast(result.message);
        return;
      } else {
        if (result.data[0]) {
          let data = {
            remark: this.message?this.message:"采购入库",
            creater: localStorage.getItem("workcode"),
            projectErpCode: this.currentAgent.erp_code,
            img: this.img_url,
            detail: result.data,
          };
          //window.console.log(data);
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
          });
          this.flag = true;
          this.$http({
            method: "post",
            url: "/mobile/warehousingCheck",
            data,
          }).then(function (response) {
            if (response.state == 200) {
              Toast.success("入库成功");
              //window.console.log(response);
              that.$router.push("index");
            }
            this.flag = false;
          }).catch(()=>{

          }).finally(() => {
            this.flag = false;
          });
        } else {
          Toast("入库数量不能全部为空");
          return;
        }
      }
    },
    parseSubmitData(obj) {
      let newarr = [];
      let message = "";
      for (let i = 0; i < obj.length; i++) {
        if (!obj[i].rknum || obj[i].rknum == 0) {
          continue;
        }
        if (obj[i].rknum.match(/\D/g)) {
          let num = i + 1;
          message =
              message + "第" + num + "条明细,入库数量包含非数字字符或空格！\n";
        }
        if (!obj[i].pdDateStr) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择生产日期！\n";
        }
        if (!obj[i].expDateStr) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择失效日期！\n";
        }
        if (obj[i].expDateStr<obj[i].pdDateStr) {
          let num = i + 1;
          message = message + "第" + num + "条明细,失效日期小于生产日期！\n";
        }
        if (obj[i].rknum && obj[i].rknum > obj[i].remain_sign_num) {
          let num = i + 1;
          message =
              message + "第" + num + "条明细,入库数量不能超过采购数量！\n";
        }
        if (!obj[i].warehouseselected) {
          let num = i + 1;
          message = message + "第" + num + "条明细,未选择仓库！\n";
        }
        let newobj = {
          warehouseId: obj[i].warehouseselected,
          purchaseOrderNum: obj[i].purchase_order_num,
          purchaseOrderDetailId: obj[i].id,
          branduuid: obj[i].brand_uuid,
          modeluuid: obj[i].model_uuid,
          unit: obj[i].unit,
          unitcost: obj[i].unit_price,
          quantity: obj[i].rknum || "0",
          is_gift: obj[i].is_gift,
          pdDateStr: obj[i].pdDateStr,
          expDateStr: obj[i].expDateStr,
        };
        newarr.push(newobj);
      }
      return {
        message: message,
        data: newarr,
      };
    },
    toPwalist() {
      this.$router.push("/pwalist");
    },
    toOrderList() {
      //window.console.log(this.purchaseOrderInfo);
      this.$router.push({
        name: "orderlist",
        params: {
          info: this.purchaseOrderInfo,
          ordernum: this.purchaseOrderNum,
        },
      });
    },
    toastMes(index) {
      if (this.orderDetail[index].rknum.match(/\D/g)) {
        this.orderDetail[index].toastmessage = "请勿输入非数字字符或空格";
      } else if (
          this.orderDetail[index].rknum >
          this.orderDetail[index].apply_num -
          this.orderDetail[index].remain_sign_num
      ) {
        this.orderDetail[index].toastmessage = "超出数量";
      } else {
        this.orderDetail[index].toastmessage = "";
      }
    },
    afterRead(file) {
      let _this = this;
      // 此时可以自行将文件上传至服务器
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append("file", file.file); //接口需要传的参数
      file.status = "uploading";
      file.message = "上传中...";
      axios
          .post("/api/mobile/uploadFile", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              token: localStorage.getItem("userToken"),
            },
          })
          .then((res) => {
            window.console.log(res);
            let img = res.data.data.replace(/storage/i, "public");
            _this.img_url = img;
            file.status = "success";
            file.message = "上传成功";
          })
          .catch((err) => {
            file.status = "failed";
            file.message = "上传失败";
            window.console.log(err);
          });
      // this.$http.post('/mobile/uploadFile', formData,config).then(res => {//将formDate文件上传到阿里云服务器，会返回图片地址
      //     let str = res.response_data[0];
      //     window.console.log(str);
      //      window.debugger;
      // });
    },
  },
  computed: {
    ...mapState(["permissionAgent", "defaultAgentIndex"]),
  },

  created() {
    if (this.permissionAgent) {
      let _this = this;
      this.currentAgent = this.permissionAgent.find(function (item) {
        return item.id == _this.defaultAgentIndex;
      });
      this.$http
          .post("/mobile/orderToBeSigned", {
            projectErpCode: this.currentAgent.erp_code,
          })
          .then(function (response) {
            if (response) {
              _this.purchaseOrderInfo = response;
              if (!response.purchaseOrderData[0]) {
                _this.purchaseOrderNum = "暂无订单";
              } else {
                _this.checker = response.checker;
                _this.purchaseOrderNum =
                    _this.$route.params.ordernum ||
                    response.purchaseOrderData[0].purchase_order_num;
                _this.purchaseOrderDetailinfo = response.purchaseOrderData.find(
                    function (item) {
                      return item.purchase_order_num == _this.purchaseOrderNum;
                    }
                );
                _this.purchaseOrderDetailinfo.detail.forEach((v,k) => {
                  _this.orderDetail[k]=v;
                  _this.orderDetail[k].pdDateRaw = new Date();
                  _this.orderDetail[k].expDateRaw = new Date();
                });
              }
            }
          });
    } else {
      let _this = this;
      this.$http
          .post("/mobile/rimsAgentList", {
            username: localStorage.getItem("usermobile"),
          })
          .then(function (response) {
            if (response) {
              _this.changePermissionAgent(response.rimsAgent);
              _this.changeDefaultAgentIndex(response.rimsAgent[0].id);
              _this.currentAgent = _this.permissionAgent.find(function (item) {
                return item.id == _this.defaultAgentIndex;
              });
              _this.$http
                  .post("/mobile/orderToBeSigned", {
                    projectErpCode: _this.currentAgent.erp_code,
                  })
                  .then(function (response) {
                    if (response) {
                      _this.purchaseOrderInfo = response;
                      if (!response.purchaseOrderData[0]) {
                        _this.purchaseOrderNum = "暂无订单";
                      } else {
                        _this.checker = response.checker;
                        _this.purchaseOrderNum =
                            _this.$route.params.ordernum ||
                            response.purchaseOrderData[0].purchase_order_num;
                        _this.purchaseOrderDetailinfo = response.purchaseOrderData.find(
                            function (item) {
                              return (
                                  item.purchase_order_num == _this.purchaseOrderNum
                              );
                            }
                        );
                        _this.purchaseOrderDetailinfo.detail.forEach((v,k) => {
                          _this.orderDetail[k]=v;
                          _this.orderDetail[k].pdDateRaw = new Date();
                          _this.orderDetail[k].expDateRaw = new Date();
                        });
                      }
                    }
                  });
            }
          });
    }
  },
};
</script>
<style scoped lang="less">
.van-nav-bar__title {
  font-weight: 800;
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}
.van-nav-bar .van-icon {
  color: white;
}

.haha .van-cell {
  line-height: 1.2rem !important;
  border: 1px solid #dadae4;
  margin-bottom: 10px;
}
.ha {
  border-bottom: 0.2px solid #dcdcdc;
  font-weight: bold;
}
.haha .selecteddetail {
  /*background: #F4A460;*/
  background: #fafafa;
  border: 1px solid #dadae4;
}
.van-tag {
  margin-left: 2%;
}
.selected {
  background-color: #e2f3e2 !important;
  color: #32ca72 !important;
}
.van-button {
  width: 100%;
}
#aaa {
  width: 100vw;
  height: 46px;
}
.van-nav-bar__title {
  font-weight: 800;
  color: #323233;
}
.van-nav-bar .van-icon {
  color: rgba(0, 0, 0, 0.7);
}
.van-tag--default {
  background-color: #f7f8fa;
}
.choiceWarhouse .van-tag {
  padding: 0.6em 1.5em !important;
  /*font-weight: bold;*/
  font-size: 0.4rem;
  margin: 0.2em;
  color: #323233;
  border-radius: 10px;
}
.van-cell-group__title {
  color: #323233 !important;
  font-weight: bold;
  font-size: 0.38rem;
  background-color: #f7f8fa;
}
.van-cell {
  color: #969799 !important;
}
.van-tag--danger.van-tag--plain {
  color: rgb(131, 134, 131);
}
.upload-img {
  display: flex;
  flex-wrap: wrap;
}
.img-box {
  width: 88px;
  height: 88px;
  margin-right: 8px;
  margin-bottom: 8px;
}
.image {
  width: 88px;
  height: 88px;
}
.dialogDiv {
  height: 250px;
  overflow: auto;
}
</style>